import server from "../../../server";


export async function fetchReporteeAttendance(pageNumber:number,pageSize?:number,startDate?:string,endDate?:string,
                                              employeeId?:string,sortField?:string,sortDirection?:string
,status?:string){
    const res=await server.attendance.supervisor.list(pageNumber,pageSize??10,startDate,endDate,employeeId,
        sortField,sortDirection,status);
    return res;
}

export async function fetchTeamSummary() {
  const res=await server.attendance.supervisor.getTeamSummary();
  return res;
}


